import { Fragment } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

import { Button } from "@mui/material";
import { lighten } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import { useSnackbar } from "notistack";

import WizardAssessmentParticipants from "../assessments/wizardAssessmentParticipants";
import WizardAssessmentResults from "../assessments/wizardAssessmentResults";
import WizardAssessmentSelection from "../assessments/wizardAssessmentSelection";
import WizardPerformAssessment from "../assessments/wizardPerformAssessment";
import Dialog from "../ui/omniDialog";
import DialogTitle from "../ui/omniDialogTitle";

const AssessmentPreviewWizardDialog = props => {
  const {
    open,
    displayResultsAssessmentODM = null,
    dialogTitle = "Preview Assessment",
    maxWidth = "sm",
    fullWidth = true,
    autoStartAssessment = true,
    previewAssessmentODM,
  } = props;

  const theme = useTheme();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [tabIndex, setTabIndex] = useState(0);

  //Set by tab 0
  const [assessmentODM, setAssessmentODM] = useState(previewAssessmentODM);
  //set by tab 1
  const [assessmentProctorODM, setAssessmentProctorODM] = useState(null);
  const [assessmentSubjectODM, setAssessmentSubjectODM] = useState(null);
  //set by tab 2
  const [completedAssessmentODM, setCompletedAssessmentODM] = useState(null);
  const [updatedSubjectODM, setUpdatedSubjectODM] = useState(null);
  const [updatedProctorODM, setUpdatedProctorODM] = useState(null);
  //Tab 3 is the Results tab

  useEffect(() => {
    if (displayResultsAssessmentODM) {
      setTabIndex(3);
      setCompletedAssessmentODM(displayResultsAssessmentODM);
    }
  }, [setTabIndex, displayResultsAssessmentODM, setCompletedAssessmentODM]);

  useEffect(() => {
    if (assessmentODM && tabIndex === 0) {
      setTabIndex(1);
    }
  }, [tabIndex, setTabIndex, assessmentODM]);

  useEffect(() => {
    if (assessmentProctorODM && assessmentSubjectODM && tabIndex === 1) {
      setTabIndex(2);
    }
  }, [assessmentProctorODM, assessmentSubjectODM, tabIndex, setTabIndex]);

  useEffect(() => {
    if (completedAssessmentODM && updatedSubjectODM && updatedProctorODM && tabIndex === 2) {
      setTabIndex(3);
    }
  }, [tabIndex, setTabIndex, completedAssessmentODM, updatedSubjectODM, updatedProctorODM]);

  const onCloseHandler = () => {
    props.onClose();
  };

  const startOver = () => {
    setTabIndex(0);
    setAssessmentODM(null);
    setAssessmentProctorODM(null);
    setAssessmentSubjectODM(null);
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          enqueueSnackbar("Are you sure you want to quit?", {
            variant: "warning",
            action: key => (
              <Fragment>
                <Button
                  sx={{
                    marginLeft: "4px",
                    backgroundColor: lighten(theme.palette.warning.main, 0.5),
                    border: `2px solid ${lighten(theme.palette.warning.main, 0.75)}`,
                    "&:hover": {
                      backgroundColor: lighten(theme.palette.warning.main, 0.5),
                    },
                  }}
                  color="info"
                  variant="contained"
                  onClick={() => {
                    onCloseHandler();
                    closeSnackbar(key);
                  }}
                >
                  Yes
                </Button>
                <Button
                  sx={{
                    marginLeft: "4px",
                    backgroundColor: lighten(theme.palette.warning.main, 0.5),
                    border: `2px solid ${lighten(theme.palette.warning.main, 0.95)}`,
                    "&:hover": {
                      backgroundColor: lighten(theme.palette.warning.main, 0.5),
                    },
                  }}
                  color="info"
                  variant="contained"
                  onClick={() => {
                    closeSnackbar(key);
                  }}
                >
                  No
                </Button>
              </Fragment>
            ),
          });
        }
      }}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      keepMounted
    >
      <DialogTitle
        onClose={() => {
          if (displayResultsAssessmentODM) {
            onCloseHandler();
          } else {
            enqueueSnackbar("Are you sure you want to quit?", {
              variant: "warning",
              action: key => (
                <Fragment>
                  <Button
                    sx={{
                      marginLeft: "4px",
                      backgroundColor: lighten(theme.palette.warning.main, 0.5),
                      border: `2px solid ${lighten(theme.palette.warning.main, 0.75)}`,
                      "&:hover": {
                        backgroundColor: lighten(theme.palette.warning.main, 0.5),
                        filter: "brightness(85%)",
                      },
                    }}
                    color="info"
                    variant="contained"
                    onClick={() => {
                      onCloseHandler();
                      closeSnackbar(key);
                    }}
                  >
                    Yes
                  </Button>
                  <Button
                    sx={{
                      marginLeft: "4px",
                      backgroundColor: lighten(theme.palette.warning.main, 0.5),
                      border: `2px solid ${lighten(theme.palette.warning.main, 0.95)}`,
                      "&:hover": {
                        backgroundColor: lighten(theme.palette.warning.main, 0.5),
                        filter: "brightness(85%)",
                      },
                    }}
                    color="info"
                    variant="contained"
                    onClick={() => {
                      closeSnackbar(key);
                    }}
                  >
                    No
                  </Button>
                </Fragment>
              ),
            });
          }
        }}
      >
        {assessmentODM !== null ? `Preview: ${assessmentODM.omniData.title}` : dialogTitle}
      </DialogTitle>
      {tabIndex === 0 && (
        <WizardAssessmentSelection
          lockAssessmentOmniType={previewAssessmentODM}
          autoStartAssessment={autoStartAssessment}
          key={"WizardAssessmentSelection"}
          setAssessmentODM={setAssessmentODM}
        />
      )}
      {tabIndex === 1 && (
        <WizardAssessmentParticipants
          key={"WizardAssessmentParticipants"}
          onCancel={startOver}
          setAssessmentProctorODM={setAssessmentProctorODM}
          setAssessmentSubjectODM={setAssessmentSubjectODM}
        />
      )}
      {tabIndex === 2 && (
        <WizardPerformAssessment
          key={"WizardPerformAssessment"}
          onCancel={startOver}
          originalAssessmentODM={assessmentODM}
          subjectODM={assessmentSubjectODM}
          proctorODM={assessmentProctorODM}
          setCompletedAssessmentODM={setCompletedAssessmentODM}
          setUpdatedSubjectODM={setUpdatedSubjectODM}
          setUpdatedProctorODM={setUpdatedProctorODM}
        />
      )}

      {tabIndex === 3 && (
        <WizardAssessmentResults
          key={"WizardAssessmentResults"}
          completedAssessmentODM={completedAssessmentODM}
          updatedSubjectODM={updatedSubjectODM}
          updatedProctorODM={updatedProctorODM}
          onClose={onCloseHandler}
        />
      )}
    </Dialog>
  );
};

const mapStateToProps = state => ({
  assessmentTemplates: state.assessmentSession.assessmentTemplates,
  assessmentTemplateODM: state.assessmentSession.assessmentTemplateODM,
  awsGroup: state.userSession.awsGroup,
});

export default connect(mapStateToProps)(AssessmentPreviewWizardDialog);
